<template>
  <Icon :color="color" :left="left" :right="right" :disabled="disabled" iconName="mdi-pencil" @click="onClick" />
</template>

<script>
import Icon from '@/components/atoms/base/icon/Icon'

export default {
  name: 'IconEdit',

  components: {
    Icon,
  },

  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
